export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
    ColorText: '#D97745',
    MetricsColor: {
      DotColor: '#F6C6A8',
      LineColor: '#F6C6A8',
    },
    primary: false,
    secondary: false,
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
    ColorText: '#FFFFFF',
    primary: false,
    secondary: false,
  },
  LEAD: {
    Title: 'Lead',
    primary: true,
    secondary: false,
    Color: '#F8EEDC',
    ColorBorder: '#FFFFFF',
    ColorText: '#7E511E',
    MetricsColor: {
      DotColor: '#E2C997',
      LineColor: '#E2C997',
    },
  },
  CONTACT_MADE: {
    Title: 'Contact Made',
    primary: true,
    secondary: false,
    Color: '#E2F7FB',
    ColorBorder: '#FFFFFF',
    ColorText: '#1D6671',
    MetricsColor: {
      DotColor: '#6CC7D7',
      LineColor: '#6CC7D7',
    },
  },
  DETAILS_NEEDED: {
    Title: 'Unresponsive',
    primary: true,
    secondary: false,
    Color: '#EEEDFD',
    ColorBorder: '#FFFFFF',
    ColorText: '#3A3684',
    MetricsColor: {
      DotColor: '#ACA8E0',
      LineColor: '#ACA8E0',
    },
  },
  STALLED: {
    Title: 'Stalled',
    primary: false,
    secondary: true,
    Color: '#FED89B',
    ColorText: '#5D524A',
    ColorBorder: '#FFFFFF',
    MetricsColor: {
      DotColor: '#BD9279',
      LineColor: '#BD9279',
    },
  },
  CG_SEARCH: {
    Title: 'CG Search Queued',
    primary: true,
    secondary: false,
    Color: '#E8F1FA',
    ColorBorder: '#FFFFFF',
    ColorText: '#2D5FA0',
    MetricsColor: {
      DotColor: '#94BAE1',
      LineColor: '#94BAE1',
    },
  },
  CG_SEARCH_ACTIVE: {
    Title: 'CG Search Active',
    primary: true,
    secondary: false,
    Color: '#F8EBF0',
    ColorBorder: '#FFFFFF',
    ColorText: '#692A3E',
    MetricsColor: {
      DotColor: '#ECB4CD',
      LineColor: '#ECB4CD',
    },
  },
  CG_PROFILE_SENT: {
    Title: 'CG Profile Sent',
    primary: true,
    secondary: false,
    Color: '#D8F1E7',
    ColorBorder: '#FFFFFF',
    ColorText: '#224F42',
    MetricsColor: {
      DotColor: '#A9DBC3',
      LineColor: '#A9DBC3',
    },
  },
  MEET_GREET: {
    Title: 'Meet & Greet Booked',
    primary: true,
    secondary: false,
    Color: '#E1EFCA',
    ColorBorder: '#FFFFFF',
    ColorText: '#3C5921',
    MetricsColor: {
      DotColor: '#A9CC63',
      LineColor: '#A9CC63',
    },
  },
  CLOSED_LOST: {
    Title: 'Closed Lost',
    primary: false,
    secondary: true,
    Color: '#EBEBEB',
    ColorBorder: '#FFFFFF',
    ColorText: '#555555',
    MetricsColor: {
      DotColor: '#CBCBCB',
      LineColor: '#CBCBCB',
    },
  },
};
